import { Pencil } from "lucide-react";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import styles from "../editable-select-cell.module.scss";

export function ReadOnlyView({
	value,
	displayFormatter,
	valueToSelectValue,
	isMulti,
	getOptionValue,
	getOptionLabel,
	onEdit,
	readButtonTitle,
	disabled,
	className,
}) {
	const defaultDisplayFormatter = (val) => {
		if (!val) return "—";
		const selected = valueToSelectValue(val);
		if (isMulti) {
			if (!Array.isArray(selected) || selected.length === 0) return "—";
			return (
				<div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
					{selected.map((s, index) => (
						<CustomBadge key={getOptionValue(s) || index}>{getOptionLabel(s)}</CustomBadge>
					))}
				</div>
			);
		}
		return selected ? getOptionLabel(selected) : "—";
	};

	const textToShow = typeof displayFormatter === "function" ? displayFormatter(value) : defaultDisplayFormatter(value);

	return (
		<div className={`${styles.wrapper} ${className}`}>
			<button type="button" onClick={onEdit} title={readButtonTitle} className={styles.readButton} disabled={disabled}>
				{typeof textToShow === "string" ? <span className={styles.readText}>{textToShow}</span> : textToShow}
				<Pencil className={styles.readIcon} aria-hidden="true" />
			</button>
		</div>
	);
}
